import { useForm, zodResolver } from '@mantine/form';
import { z } from 'zod';

export const customerRepresentativeSchema = z.object({
  representative: z.object({
    name: z.string().optional().nullable(),
    identificationNumber: z.string().optional().nullable(),
    identificationNumberIDMS: z.string().optional().nullable(),
    status: z.number().optional().nullable(),
    address: z.object({
      street: z.string().optional().nullable(),
      postcode: z.string().optional().nullable(),
      city: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
    }),
  }),
});
export type CustomerViewRepresentativeFormValues = z.infer<typeof customerRepresentativeSchema>;

export const useCustomerViewRepresentativeFormInitializer = ({ customerDetails }) => {
  const buildFormValues = (cd) => {
    const { representative: customerDetailsRepresentative } = cd || {};

    return {
      representative: {
        name: customerDetailsRepresentative?.name || '',
        identificationNumber: customerDetailsRepresentative?.identificationNumber || '',
        identificationNumberIDMS: customerDetailsRepresentative?.identificationNumberIDMS || '',
        status: customerDetailsRepresentative?.status || '',
        address: {
          street: customerDetailsRepresentative?.address?.street || '',
          postcode: customerDetailsRepresentative?.address?.postcode || '',
          city: customerDetailsRepresentative?.address?.city || '',
          country: customerDetailsRepresentative?.address?.country || '',
        },
      },
    };
  };

  const form = useForm<CustomerViewRepresentativeFormValues>({
    initialValues: buildFormValues(customerDetails),
    validate: zodResolver(customerRepresentativeSchema),
    validateInputOnBlur: true,
  });

  return { form, buildFormValues };
};
